import styled from 'styled-components'

const ListPageLayout = styled.div`
  background-color: ${({ theme }) => theme.token.colorBgLayout};
  padding: 16px;
  height: calc(100vh - 64px);
  border-radius: 16px 16px 0px 0px;
`

export default ListPageLayout
